import gql from 'graphql-tag';

export const GET_FEEDBACKS = gql`
  query FindFeedbacks($query: FeedbackQuery!) {
    findFeedbacks(query: $query) {
      _id
      feedbacks
      category
    }
  }
`;
